import React from "react";
import { Doughnut } from "react-chartjs-2";
import "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels"; // Import datalabels plugin
import { Chart } from "chart.js"; // Register Chart
import "./report.css"; // Custom CSS file for styling

Chart.register(ChartDataLabels); // Register the plugin

const NCRTracker = (props) => {
  const data = {
    labels: props?.data?.labels,
    datasets: [
      {
        data: [props?.data?.data[1],props?.data?.data[2]], // Percentage values
        backgroundColor: [ "#0ebd0e","rgb(216, 0, 0)"], // Colors for the sections
        hoverBackgroundColor: [ "#0ebd0e","rgb(216, 0, 0)"],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    cutout: "70%", // Inner radius for the donut
    plugins: {
      tooltip: {
        enabled: false,
      },
      legend: {
        display: false,
        position: 'right',
      },
      datalabels: {
        formatter: (value) => {
          return `${value}%`; // Show the percentage in the center
        },
        color: '#FFF',
        font: {
          weight: 'bold',
        //   size: 18, // Optional: Set the font size
        },
        align: 'center', // Ensure labels are centered
        anchor: 'center', // Position the label in the center
      },
    },
  };

  return (
    <div className="ncr-tracker">
      <div className="chart-container">
        <Doughnut data={data} options={options} />
        <div className="chart-center">
          <span className="total-count">{props?.data?.total}</span><br/>
          <span className="total-label">{props?.label}</span>
        </div>
      </div>
      <div className="chart-legend">
        <div className="legend-item">
          <div className="legend-color closed"></div>
          <span>Closed NCR</span>
        </div>
        <div className="legend-item">
          <div className="legend-color open"></div>
          <span>Open NCR</span>
        </div>
      </div>
    </div>
  );
};

export default NCRTracker;
